import { Component, OnInit, ViewChild, Optional, ViewContainerRef } from '@angular/core';
import { LineBotService } from '../../_services/line-bot.service';
import { CoinConfigService } from '../../_services/coinconfig.service';
import { Observable } from 'rxjs/Observable';
import { DialogService } from 'ng2-bootstrap-modal';
import { AddLineBotComponent } from './add-line-bot-account/add-line-bot-account.component';
import { ConfirmComponent } from '../../_common/confirm/confirm.component';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'app-root',
    templateUrl: './line-bot-account.component.html',
    styleUrls: ['./line-bot-account.component.css']
})
export class LineBotAccountComponent implements OnInit {
    model: any = {};
    loading: boolean = false;
    message: string = '';
    pairs: Observable<any[]>;
    dataPairs: any[] = [];
    objectPairs: any = {};
    pairId: string;
    delayTimer: any;
    dtTrigger: Subject<any> = new Subject();

    // config DataTables
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    // declare parameters object
    parameters: any = {};

    // declare callback object
    callback: any = {};
    typeArray : any = {
        1 : "コインのコンフィグ",
        2 : "その他"
    };

    constructor(
        private lineBotService: LineBotService,
        private coinConfigService: CoinConfigService,
        private dialogService: DialogService) { }

    ngOnInit() {
        this.registerTable();
        this.pairs = this.coinConfigService.getPairs();
        this.pairs.subscribe(data => {
            this.dataPairs = data;
            data.forEach(element => {
                this.objectPairs[element.id] = element.name;
            });
            this.dtTrigger.next();
        });
    }

    registerTable() {
        const self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, 'desc']],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            autoWidth: false,
            ajax: function (parameters, callback, settings) {
                // assign parameters object
                self.parameters = parameters;

                // assign callback object
                self.callback = callback;

                self.lineBotService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                    name: 'id',
                    className: 'all text-justify',
                },
                {
                    title: 'LINEボットチャンネル名',
                    data: 'linebot_channel_name',
                    name: 'linebot_channel_name',
                    className: 'all text-justify',
                },
                {
                    title: 'LINEボットチャンネルトークン',
                    data: 'linebot_channel_token',
                    name: 'linebot_channel_token',
                    className: 'all text-justify',
                    render: function (data, type, full, meta) {
                        return '<div style="white-space: pre-wrap; word-break: break-all; word-wrap: break-word;">' + data + '</div>';
                    },
                },
                {
                    title: 'LINEボットチャネルのシークレット',
                    data: 'linebot_channel_secret',
                    name: 'linebot_channel_secret',
                    className: 'all text-justify',
                },
                {
                    title: 'qr code',
                    data: 'qr_code',
                    name: 'qr_code',
                    className: 'all text-justify',
                    render: function (urlImage) {
                        return '<img src="' + urlImage + '" alt="QR CODE" height="180" width="180" />';
                    },
                },
                {
                    title: 'タイプ',
                    data: function (data) {
                        return self.typeArray[data.type];
                    },
                    name: 'type',
                    className: 'all text-justify',
                },
                {
                    title: '',
                    data: 'btn_is_active',
                    width: '60px',
                    className: 'all text-center',
                    orderable: false
                },
                {
                    title: '',
                    data: function (d) {
                        return `<button class="btn btn-sm btn-primary btn-edit">編集</button>`;
                    },
                    width: '60px',
                    className: 'all text-center',
                    orderable: false
                },
                {
                    title: '',
                    data: function (d) {
                        return `<button class="btn btn-sm btn-danger btn-delete">削除</button>`;
                    },
                    width: '60px',
                    className: 'all text-center',
                    orderable: false
                }
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self1 = this;
                $('.btn-active', row).bind('click', () => {
                    self1.openActive(data);
                });

                $('.btn-edit', row).bind('click', () => {
                  self1.openEdit(data);
                });

                $('.btn-delete', row).bind('click', () => {
                    self1.confirmDelete(data);
                });

                return row;
            }
        };
    }

    onChange(event) {
        this.rerenderDataTable();
    }

    doSearch() {
        const self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600);
    }

    openActive(data) {
        this.lineBotService.active(data).subscribe(data1 => {
            this.loadCurrentPage();
        }, error => {

        });
    }

    openEdit(data) {
        this.dialogService.addDialog(AddLineBotComponent, {
            id: data.id,
            linebot_channel_name: data.linebot_channel_name,
            linebot_channel_token: data.linebot_channel_token,
            linebot_channel_secret: data.linebot_channel_secret,
            qr_code: data.qr_code,
            type : data.type
        }).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    confirmDelete(data) {
        this.dialogService.addDialog(ConfirmComponent, {
            title: '確認',
            message: '削除しますが、よろしいでしょうか？'
        }).subscribe((isConfirmed) => {
            if (isConfirmed) {
                this.lineBotService.delete(data.id).subscribe(data1 => {
                    this.loadCurrentPage();
                }, error => {

                });
            }
        });
    }

    openModalAddGroupLine() {
        const self = this;
        this.dialogService.addDialog(AddLineBotComponent, {}).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    loadCurrentPage() {

        // get parameters and retrive result of current page
        this.lineBotService.gets(this.parameters).subscribe(result => {

            // use callback function
            this.callback({

                // retrive draw current
                draw: this.parameters['draw'],

                // retrive data of current page
                data: result.data,

                // retrive number records per page
                recordsTotal: result.data.length,

                // retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/line-bot-account/line-bot-account.component.ts